import { Card, CardContent } from "@/core/components/ui/card";
import { Typography } from "@/core/components/ui/typography";
import { DETAIL_CARD_TOP_MARGIN } from "@/activity-feed/card-spacing-constants";
import { cn } from "@/core/utils/utils";
import { SpiffRuleEvent } from "@/spiff-rules/spiff-rule";

interface DetailCardProps {
  children: React.ReactNode;
  eventType?: SpiffRuleEvent;
}

export const DetailCard = ({ children, eventType }: DetailCardProps) => (
  <Card
    className={cn(
      "mx-4 w-[618px] rounded-2xl bg-[#f9f9f9]",
      eventType ? DETAIL_CARD_TOP_MARGIN[eventType] : "-mt-16",
    )}
  >
    <CardContent className="p-4">{children}</CardContent>
  </Card>
);

export const InfoPair = ({
  label,
  value,
}: {
  label: string;
  value: string | null | undefined;
}) => (
  <Typography variant="bodyW2">
    <span className="text-secondary-text">{label}:</span> {value ?? "—"}
  </Typography>
);
